import {createSlice} from "@reduxjs/toolkit";

const initialUsersLedgerReportState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  exportData: [], 
  userLedgerSummary: [], 
  ledgerResposne:null,
  companyDetails:null
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const UsersLedgerReportSlice = createSlice({
  
  name: "usersLedgerReport",
  initialState: initialUsersLedgerReportState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },
    
    usersLedgerReportList: (state, action) => {
      const { totalCount, entities,ledgerResposne } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.ledgerResposne=ledgerResposne;
      state.totalCount = totalCount;
    },
    usersLedgerReportExport: (state, action) => {
      const { exportData } = action.payload;
      // state.listLoading = false;
      // state.error = null;
      state.exportData = exportData;
    },
    usersLedgerReportSummary: (state, action) => {
      const { userLedgerSummary } = action.payload;
      // state.listLoading = false;
      // state.error = null;
      state.userLedgerSummary = userLedgerSummary;
    },
    usersLedgersList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    usersLedgersExport: (state, action) => {
      const { exportData } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.exportData = exportData;
    },
    companyDetailsResponse:(state,action)=>{
      const { companyDetails } = action.payload;

      state.companyDetails = companyDetails;
    }
  }
});
